import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate, useLocation } from 'react-router-dom';
import { Constants } from '../lib/const/constants';
import { getCurrencySymbol } from '../lib/currenyUtils';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { encryptPayload } from '../utils/encryption';
import { ArrowLeft, ArrowRight } from 'lucide-react';

export default function ConversionReview() {
  const navigate = useNavigate();
  const location = useLocation();
  const s = location.state || {};

  // console.log('ConversionReview state:', s);

  const [loading, setLoading] = useState(false);

  const sellCurrency = s.sellCurrency || '';
  const buyCurrency = s.buyCurrency || '';
  const exchangeRate = s.exchangeRate || 0;
  const convertDate = s.convertDate || '';
  console.log("conversion Date",convertDate);
  const convertTime = s.convertTime || '';
  const amount = s.amount || '';
  const buyAmount = s.buyAmount || '';
  const contactId = s.contactId || '';
  const from_currency = s.from_currency || '';
  const receiveCurrencyValue = s.receiveCurrencyValue || '';
  const sellFlagUrl = s.sellFlagUrl || '';
  const buyFlagUrl = s.buyFlagUrl || '';
  const availableBalance = s.availableBalance;

  const getFlagUrl = (currencyCode) => {
    const overrides = {
      EUR: 'eu.png',
      RON: 'ro.png',
      DKK: 'dk.png',
      NOK: 'no.png',
      SEK: 'se.png',
      MYR: 'my.png',
    };
    if (overrides[currencyCode])
      return `${Constants.FXMASTER_BASE_URL}flags/${overrides[currencyCode]}`;
    const map = {
      AUD: 'AU.PNG',
      GBP: 'GB.PNG',
      USD: 'US.PNG',
      EUR: 'eu.png',
      INR: 'IN.PNG',
      CAD: 'CA.PNG',
      HKD: 'HK.PNG',
      SGD: 'SG.PNG',
      AED: 'AE.PNG',
      JPY: 'JP.PNG',
      CHF: 'CH.PNG',
      NZD: 'NZ.PNG',
      ZAR: 'ZA.PNG',
      TRY: 'TR.PNG',
      THB: 'TH.PNG',
      MXN: 'MX.PNG',
      PLN: 'PL.PNG',
      CZK: 'CZ.PNG',
      HUF: 'HU.PNG',
      ILS: 'IL.PNG',
    };
    const file =
      map[currencyCode] || `${currencyCode?.slice(0, 2)?.toUpperCase()}.PNG`;
    return `${Constants.FXMASTER_BASE_URL}flags/${file}`;
  };

  const fromFlag = sellFlagUrl || getFlagUrl(from_currency || sellCurrency);
  const toFlag = buyFlagUrl || getFlagUrl(receiveCurrencyValue || buyCurrency);

  const updateConvert = async () => {
    // console.log('🔎 updateConvert called');
    setLoading(true);
    if (!amount || parseFloat(amount) > parseFloat(availableBalance)) {
      toast.error('Insufficient Funds.');
      return;
    }
    const workspaceId = sessionStorage.getItem('login_workspaces_id');
    const token = sessionStorage.getItem('login_token');
    try {
      const encryptedPayload = await encryptPayload({ workspace_id: workspaceId, contact_id: contactId,platform: 'web',
          extraParamValidation: 'trustedfromweb' });
      const resp = await axios.post(
        Constants.CURRENCY.includes(Constants.CURRENCYID[receiveCurrencyValue])
          ? Constants.BASE_URL + 'API-FX-232-WALLET-CONVERSION'
          : Constants.BASE_URL + 'API-FX-232-WALLET-CONVERSION',
        encryptedPayload,
        {
          headers: {
            fx_key: Constants.SUBSCRIPTION_KEY,
            Authorization: 'Bearer ' + JSON.parse(token),
          },
        },
      );
      setLoading(false);
      if (resp.data.code !== 400) {
        navigate('/Conversionsuccess');
        setTimeout(() => navigate('/Conversions'), 5000);
      } else {
        toast.error(resp.data.message);
      }
    } catch (err) {
      setLoading(false);
      toast.error(err.response?.data?.message || 'Something went wrong.');
    }
  };

  const validateWorkspaceConfig = async () => {
    setLoading(true);
    const workspaceId = sessionStorage.getItem('login_workspaces_id');

    if (s.receiveCurrencyId != 231) {
      await axios
        .post(
          Constants.BASE_URL + '/API-FX-242-WORKSPACE-CONFIG-VALIDATION',
          { workspace_id: workspaceId },
          { headers: { fx_key: Constants.SUBSCRIPTION_KEY } },
        )
        .then((resp) => {
          const keys = Object.keys(resp.data);
          // console.log(keys);
          // console.log(receiveCurrencyValue);
          if (keys.includes(receiveCurrencyValue)) {
            updateConvert();
          } else {
            setLoading(false);
            toast.error(
              'Please contact administrator to activate the service.',
            );
          }
        })
        .catch((err) => {
          console.log(err);
          setLoading(false);
          toast.error('Please contact administrator to activate the service.');
        });
    } else if (location.pathname === '/SendMoneyTab') {
      navigate('/SendMoneyCurrency', {
        state: {
          currency: receiveCurrencyValue,
          buyAmount: buyAmount,
          exchangeRate: exchangeRate,
          contactId: contactId,
          from_currency: from_currency,
          from_amount: amount,
          Nav_node: 2,
        },
      });
    } else {
      updateConvert();
    }
  };
  return (
    <div
      style={{
        padding: '1.5rem 1rem',
        maxWidth: 680,
        margin: '0 auto',
        minHeight: '100vh',
        background: 'linear-gradient(to bottom, #f8fafc, #eff6ff4d, #eef2ff66)',
      }}
    >
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
      />
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          marginBottom: '1.5rem',
          position: 'relative',
        }}
      >
        <button
          onClick={() => navigate(-1)}
          style={{
            ...backBtnStyle,
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            gap: '0.4rem',
            fontSize: '0.95rem',
            fontWeight: 600,
            color: '#0B214E',
            padding: 0,
          }}
          aria-label="Back"
        >
          <ArrowLeft className="w-5 h-5 -mr-1" />
         <span>Back</span>
        </button>
        <h2
          style={{
            fontSize: '1.25rem',
            fontWeight: 800,
            color: '#0B214E',
            margin: 0,
            position: 'absolute',
            left: '50%',
            transform: 'translateX(-50%)',
          }}
        >
          Conversion Review
        </h2>
      </div>
      <div
        className="bg-white"
        style={{
          ...cardStyle,
          borderRadius: '1.25rem',
          boxShadow: '0 2px 16px rgba(11,33,78,0.07)',
          padding: '1.5rem',
          marginBottom: '1.25rem',
        }}
      >
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            marginBottom: '1.25rem',
          }}
        >
          <div
            style={{ display: 'flex', alignItems: 'center', gap: '0.65rem' }}
          >
            <img
              src={fromFlag}
              alt={from_currency || sellCurrency}
              style={{
                ...flagImgStyle,
                width: 36,
                height: 36,
                borderRadius: '50%',
                objectFit: 'cover',
                border: '1px solid #e2e8f0',
              }}
              onError={(e) => {
                e.target.style.display = 'none';
              }}
            />
            <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
              <span style={{ ...flagLabelStyle, display: 'none' }}>FROM</span>
              <span
                style={{
                  ...flagCurrencyStyle,
                  fontSize: '1rem',
                  fontWeight: 700,
                  color: '#0B214E',
                }}
              >
                {from_currency || sellCurrency}
              </span>
              <span
                style={{
                  fontSize: '0.88rem',
                  fontWeight: 500,
                  color: '#64748b',
                }}
              >
                {getCurrencySymbol(from_currency || sellCurrency)}{' '}
                {parseFloat(amount).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </span>
            </div>
          </div>
          <div
            style={{
              ...arrowCircleStyle,
              width: 36,
              height: 36,
              borderRadius: '50%',
              background: '#F1F5F9',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '1.1rem',
              color: '#0B214E',
              fontWeight: 700,
            }}
          >
            <ArrowRight className="w-5 h-5" />
          </div>

          <div
            style={{ display: 'flex', alignItems: 'center', gap: '0.65rem' }}
          >
            <img
              src={toFlag}
              alt={receiveCurrencyValue || buyCurrency}
              style={{
                ...flagImgStyle,
                width: 36,
                height: 36,
                borderRadius: '50%',
                objectFit: 'cover',
                border: '1px solid #e2e8f0',
              }}
              onError={(e) => {
                e.target.style.display = 'none';
              }}
            />
            <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
              <span style={{ ...flagLabelStyle, display: 'none' }}>TO</span>
              <span
                style={{
                  ...flagCurrencyStyle,
                  fontSize: '1rem',
                  fontWeight: 700,
                  color: '#0B214E',
                }}
              >
                {receiveCurrencyValue || buyCurrency}
              </span>
              <span
                style={{
                  fontSize: '0.88rem',
                  fontWeight: 500,
                  color: '#64748b',
                }}
              >
                {getCurrencySymbol(receiveCurrencyValue || buyCurrency)}{' '}
                {parseFloat(buyAmount).toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </span>
            </div>
          </div>
        </div>

        <div
          style={{
            border: '1px solid #E6E5E5',
            background: '#FCFCFC',
            borderRadius: '0.9rem',
            padding: '1rem 1.25rem',
          }}
        >
          <p
            style={{
              fontSize: '0.95rem',
              fontWeight: 700,
              color: '#0B214E',
              margin: '0 0 0.75rem 0',
            }}
          >
            Conversion Details
          </p>

          <div style={{ ...rowStyle, borderTop: 'none', paddingTop: 0 }}>
            <span style={{ ...rowLabelStyle }}>Sell Amount</span>
            <span style={{ ...rowValueStyle }}>
              {getCurrencySymbol(from_currency || sellCurrency)}{' '}
              {parseFloat(amount).toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </span>
          </div>

          <div style={{ ...rowStyle, borderTop: 'none' }}>
            <span style={{ ...rowLabelStyle }}>Buy Amount</span>
            <span style={{ ...rowValueStyle }}>
              {getCurrencySymbol(receiveCurrencyValue || buyCurrency)}{' '}
              {parseFloat(buyAmount).toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </span>
          </div>

          {convertDate ? (
            <div style={{ ...rowStyle, borderTop: 'none' }}>
              <span style={{ ...rowLabelStyle }}>Date & Time</span>
              <span
                style={{ ...rowValueStyle, fontWeight: 700, color: '#0B214E' }}
              >
                {convertDate} {convertTime}
              </span>
            </div>
          ) : null}

          <div style={{ ...rowStyle, borderTop: 'none' }}>
            <span
              style={{ ...rowLabelStyle, fontWeight: 700, color: '#0B214E' }}
            >
              Exchange Rate
            </span>
            <span
              style={{ ...rowValueStyle, fontWeight: 700, color: '#0B214E' }}
            >
              1 {from_currency || sellCurrency} ={' '}
              {parseFloat(exchangeRate).toFixed(2)}{' '}
              {receiveCurrencyValue || buyCurrency}
            </span>
          </div>
        </div>
      </div>

      <button
        type="button"
        disabled={loading}
        style={{
          ...convertBtnStyle,
          width: '100%',
          padding: '1rem',
          borderRadius: '0.9rem',
          border: 'none',
          background: loading
            ? '#c0845a'
            : 'linear-gradient(90deg, #D96B2D 0%, #C8571A 100%)',
          color: '#fff',
          fontSize: '1.05rem',
          fontWeight: 700,
          cursor: loading ? 'not-allowed' : 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '0.5rem',
          marginBottom: '1rem',
          boxShadow: '0 4px 14px rgba(200,87,26,0.25)',
          opacity: loading ? 0.7 : 1,
        }}
        onClick={validateWorkspaceConfig}
      >
        {loading ? (
          <span
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 8,
              justifyContent: 'center',
            }}
          >
            <div style={spinnerStyle} />
            Processing...
          </span>
        ) : (
          <>Confirm To Convert <ArrowRight className="w-5 h-5" /></>
        )}
      </button>

      <div
        style={{
          background: '#F4EBE5',
          borderRadius: '0.9rem',
          padding: '1rem 1.25rem',
          display: 'flex',
          alignItems: 'flex-start',
          gap: '0.75rem',
        }}
      >
        <span style={{ fontSize: '1.1rem', marginTop: '0.1rem' }}>🔒</span>
        <div>
          <p
            style={{
              fontSize: '0.92rem',
              fontWeight: 700,
              color: '#C8571A',
              margin: '0 0 0.2rem 0',
            }}
          >
            100% Secure & Safe
          </p>
          <p
            style={{
              fontSize: '0.82rem',
              color: '#64748b',
              margin: 0,
              lineHeight: 1.5,
            }}
          >
            Your money is protected with bank-level encryption. We never store
            your banking credentials.
          </p>
        </div>
      </div>
    </div>
  );
}

const cardStyle = {
  background: '#ffffff',
  borderRadius: '1.25rem',
  border: 'none',
  marginBottom: '1.25rem',
  overflow: 'hidden',
  boxShadow: '0 2px 16px rgba(11,33,78,0.07)',
};

const backBtnStyle = {
  background: 'none',
  border: 'none',
  display: 'flex',
  alignItems: 'center',
  gap: '0.4rem',
  cursor: 'pointer',
  fontSize: '0.95rem',
  fontWeight: 600,
  color: '#0B214E',
  padding: 0,
  outline: 'none',
  flexShrink: 0,
};

const flagImgStyle = {
  width: 36,
  height: 36,
  borderRadius: '50%',
  objectFit: 'cover',
  border: '1px solid #e2e8f0',
  flexShrink: 0,
};

const flagLabelStyle = {
  fontSize: '0.68rem',
  color: '#94a3b8',
  fontWeight: 500,
  letterSpacing: '0.07em',
  marginBottom: 2,
  display: 'none',
};

const flagCurrencyStyle = {
  fontSize: '1rem',
  fontWeight: 700,
  color: '#0B214E',
};

const arrowCircleStyle = {
  width: 36,
  height: 36,
  borderRadius: '50%',
  background: '#F1F5F9',
  border: 'none',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: '1.1rem',
  color: '#0B214E',
  fontWeight: 700,
  flexShrink: 0,
};

const rowStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '0.6rem 0',
};

const rowLabelStyle = {
  fontSize: '0.88rem',
  color: '#64748b',
  fontWeight: 400,
};

const rowValueStyle = {
  fontSize: '0.92rem',
  color: '#0B214E',
  fontWeight: 600,
  textAlign: 'right',
};

const convertBtnStyle = {
  width: '100%',
  padding: '1rem',
  background: 'linear-gradient(90deg, #D96B2D 0%, #C8571A 100%)',
  color: '#fff',
  fontWeight: 700,
  fontSize: '1.05rem',
  border: 'none',
  borderRadius: '0.9rem',
  cursor: 'pointer',
  marginBottom: '1rem',
  boxShadow: '0 4px 14px rgba(200,87,26,0.25)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '0.5rem',
};

const spinnerStyle = {
  width: 16,
  height: 16,
  border: '2px solid rgba(255,255,255,0.3)',
  borderTop: '2px solid #fff',
  borderRadius: '50%',
  animation: 'spin 0.7s linear infinite',
  display: 'inline-block',
};
